import BaseIcon from './BaseIcon.vue';
import IconGlyph from './IconGlyph.vue';

export { BaseIcon, IconGlyph };
